import { HomeRoutes } from './homeRoutes';
import { CartRoutes } from './cartRoutes';
import { ProfileRoutes } from './profileRoutes';
import { AuthRoutes } from './authRoutes';
import { VideoDetailRoutes } from './videoDetailRoutes';
import { LicensingRoutes } from './licensingRoutes';
import { UploadRoutes } from './uploadRoutes';
import { OnboardingRoutes } from './onboardingRoutes';
import { CollectionsRoutes } from './collectionsRoutes';
import { AdminRoutes } from './adminRoutes';
import { ModificationRoutes } from './modificationRoutes';
import { AdminRequestRoutes, MyRequestsRoutes } from './myRequestsRoutes';

export const AppRoutes = [...HomeRoutes, ...CartRoutes, ...ProfileRoutes, ...AuthRoutes, ...VideoDetailRoutes, ...LicensingRoutes, ...UploadRoutes, ...OnboardingRoutes, ...CollectionsRoutes, ...AdminRoutes, ...ModificationRoutes, ...MyRequestsRoutes, ...AdminRequestRoutes];
